/**
 * Ruta `/servicio-suspendido` (US5, T049): destino de `fermin:company-suspended`
 * (`423 COMPANY_SUSPENDED`) y de Inicio con la empresa `SUSPENDED`.
 *
 * No depende de `search` ni de parámetros: el puente de `__root.tsx` navega aquí sin nada más.
 * "Ver mi asistencia" (006 · T055) lleva a `/asistencia`, de solo lectura mientras dure la
 * suspensión (R-12).
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { SuspendedScreen } from '../features/access/suspended';

export function SuspendedRoute() {
  const navigate = useNavigate();
  return (
    <SuspendedScreen
      onRetry={() => void navigate({ to: '/', replace: true })}
      onViewHistory={() => void navigate({ to: '/asistencia' })}
    />
  );
}

export const Route = createFileRoute('/servicio-suspendido')({
  component: SuspendedRoute,
});
